module.exports = __webpack_public_path__ + "static/media/1.e7f4a71d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/gifshop/gifs/1.gif
// module id = 242
// module chunks = 0